import React, { useEffect } from "react";
import { useUpdateContactUsContentMutation } from "../../../../store/services/ContactUsContentService";
import { useUpdateFaqPageContentMutation } from "../../../../store/services/FaqPageContentService";
import { Button, Col, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Dropzone from "../../../../components/Dropzone/Dropzone";
import { MdAdd, MdDelete } from "react-icons/md";


function ContactUsContentForm({ data }) {

    // const [updateFaqPageContent, { isLoading: isUpdating }] =
    //     useUpdateFaqPageContentMutation();
    const [updateContactUsContent, { isLoading: isUpdating }] =
        useUpdateContactUsContentMutation();
    const { createdAt, updatedAt, ...PageInfo } = data;

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        setValue,
    } = useForm({
        mode: "onTouched",
        defaultValues: { ...PageInfo },
    });

    const {
        fields: generalDetailsFields,
        append: appendGeneralDetail,
        remove: removeGeneralDetail,
    } = useFieldArray({
        control,
        name: "icons",
    });

    const onSubmit = async (data) => {
        const icons = data?.icons;
        if (Array.isArray(icons)) {
            data.icons = icons.map(item => ({
                ...item,
                icon: Array.isArray(item?.icon) ? item.icon[0] : item?.icon
            }));
        }


        try {
            const res = await updateContactUsContent({
                updatedData: data,
            });
            if (res?.data?.status === "success") {

                return toast.success(res?.data?.message);
            }
        } catch (error) {
            console.error("Failed to delete the meal:", error); // Handle error
        }
    };

    useEffect(() => {
        let toastId;

        if (isUpdating) {
            // Show loading toast and save the ID
            toastId = toast.loading("Updating...");
        } else if (toastId) {
            // Dismiss the loading toast when isUpdating is false
            toast.dismiss(toastId);
        }

        return () => {
            // Cleanup: Ensure toast is dismissed if the component unmounts
            if (toastId) {
                toast.dismiss(toastId);
            }
        };
    }, [isUpdating]);

    return (
        <Col lg="12" md="12" sm="12" className="my-2">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div
                    className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                    style={{ background: "#EEEEEE" }}
                >
                    <Row className="justify-content-between">
                        <Col lg="12">
                            {/* <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                                Contact us content
                            </h4> */}
                        </Col>

                        <Col lg="6" md="6" sm="6" className="my-2">
                            <div className="py-2">
                                <label className="form-label fw-sbold text-muted ps-2 m-0">
                                    Contact us heading
                                </label>
                                <input
                                    type="text"
                                    {...register("heading", {
                                        required: "Please enter contact us heading",
                                    })}
                                    className={`form-control ${errors?.heading ? "is-invalid" : ""
                                        }`}
                                />
                                {errors?.heading && (
                                    <span className="text-danger">
                                        {errors?.heading?.message}
                                    </span>
                                )}
                            </div>
                        </Col>
                        <Col lg="6" md="6" sm="6" className="my-2">
                            <div className="py-2">
                                <label className="form-label fw-sbold text-muted ps-2 m-0">
                                    Contact us description
                                </label>
                                <input
                                    type="text"
                                    {...register("desc", {
                                        required: "Please enter contact us description",
                                    })}
                                    className={`form-control ${errors?.desc ? "is-invalid" : ""
                                        }`}
                                />
                                {errors?.desc && (
                                    <span className="text-danger">
                                        {errors?.desc?.message}
                                    </span>
                                )}
                            </div>
                        </Col>
                        <Col lg="6" md="6" sm="6" className="mb-3">
                            <div className="py-2">
                                <label className="form-label fw-sbold text-muted ps-2 m-0">
                                    Contact us image
                                </label>
                                <Controller
                                    name="image"
                                    control={control}
                                    rules={{ required: "Please enter contact us image" }}
                                    render={({ field }) => (
                                        <Dropzone
                                            field="image"
                                            setFieldValue={setValue}
                                            value={field.value}
                                            error={errors}
                                        />
                                    )}
                                />
                                {errors?.image && (
                                    <span className="text-danger">
                                        {errors?.image?.message}
                                    </span>
                                )}
                            </div>
                        </Col>

                        <Col lg="12">
                            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                                Contact us icons
                            </h4>
                        </Col>

                        {generalDetailsFields.map((field, index) => (
                            <div key={field.id} className="row">
                                {/* Image Field with Dropzone */}
                                <Col lg="4" className="my-2">
                                    <div className="py-2">
                                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                                            Icon
                                        </label>
                                        <Controller
                                            name={`icons.${index}.icon`}
                                            control={control}
                                            rules={{ required: "Please enter icon" }}
                                            render={({ field }) => (
                                                <Dropzone
                                                    field={`icons.${index}.icon`}
                                                    setFieldValue={setValue}
                                                    value={field.value}
                                                    error={errors?.icons?.[index]?.icon}
                                                />
                                            )}
                                        />
                                        {errors?.icons?.[index]?.icon && (
                                            <span className="text-danger">
                                                {errors?.icons?.[index].icon.message}
                                            </span>
                                        )}
                                    </div>
                                </Col>


                                {/* Title Field */}
                                <Col lg="4" className="my-2">
                                    <div className="py-2">
                                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                                            Title
                                        </label>
                                        <input
                                            type="text"
                                            {...register(`icons.${index}.title`, {
                                                required: "Please enter title",
                                            })}
                                            className={`form-control ${errors?.icons?.[index]?.title
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                        />
                                        {errors?.icons?.[index]?.title && (
                                            <span className="text-danger">
                                                {errors?.icons?.[index]?.title.message}
                                            </span>
                                        )}
                                    </div>
                                </Col>

                                <Col lg="4" className="my-2">
                                    <div className="py-2">
                                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                                            Value
                                        </label>
                                        <input
                                            type="text"
                                            {...register(`icons.${index}.value`, {
                                                required: "Please enter value",
                                            })}
                                            className={`form-control ${errors?.icons?.[index]?.title
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                        />
                                        {errors?.icons?.[index]?.value && (
                                            <span className="text-danger">
                                                {errors?.icons?.[index]?.value.message}
                                            </span>
                                        )}
                                    </div>
                                </Col>



                                {/* Remove Button */}
                                <Col lg="12" className="text-right">
                                    <Button
                                        type="button"
                                        variant="danger"
                                        onClick={() => removeGeneralDetail(index)}
                                        className="mt-2"
                                    >
                                        <MdDelete />
                                    </Button>
                                </Col>
                            </div>
                        ))}
                        <Col lg="12" className="text-right mt-3">
                            <Button
                                type="button"
                                color="primary"
                                onClick={() => appendGeneralDetail({ icon: "", title: "", value: "", })}
                            >
                                <MdAdd />
                                Icon detail
                            </Button>
                        </Col>


                        {/* Submit Button */}
                        <Col lg="12" className="text-right my-3">
                            <Button
                                type="submit"
                                className="d-flex align-items-center justify-content-center commonBtn"
                                disabled={isUpdating}
                            >
                                Submit
                            </Button>
                        </Col>

                    </Row>
                </div>
            </form>
        </Col>
    );
}

export default ContactUsContentForm;
